import { Component, EventEmitter, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { setLoading } from 'src/app/redux/actions/user.actions';
import { AppState } from 'src/app/redux/app.state';
import { ProductInWarehouse } from 'src/typings';
import { WarehouseService } from 'src/app/warehouse/warehouse.service';

@Component({
  selector: 'app-edit-stock',
  templateUrl: './edit-stock.component.html',
  styleUrls: ['./edit-stock.component.scss']
})
export class EditStockComponent {
  @Input() set row(value: ProductInWarehouse | undefined) {
    if (!value) return;
    this._row = value;
    this.cellControl.setValue(value.cell);
  }

  get row() {
    return this._row;
  }

  private _row: ProductInWarehouse | undefined;

  set loading(value: boolean) {
    this.store.dispatch(setLoading({ payload: value }));
  }

  cellControl: UntypedFormControl = new UntypedFormControl();

  doneEvent: EventEmitter<ProductInWarehouse> = new EventEmitter();

  constructor(private warehouseService: WarehouseService, private store: Store<AppState>) {}

  save() {
    if (!this.row) return;
    this.loading = true;
    this.warehouseService
      .updateCell({
        row_id: this.row.id,
        cell: this.cellControl.value
      })
      .subscribe(
        (data) => {
          this.loading = false;
          this.doneEvent.emit(data);
        },
        (err) => {
          console.error(err);
          this.loading = false;
        }
      );
  }
}
